(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["baliveno-product-studio"] && !Shopify.designMode) return;
  try {
    (() => {
    function initialise(root) {
      if (root.dataset.bvReady) return;
      root.dataset.bvReady = 'true';
      const title = root.querySelector('[data-bv-title]');
      if (title) {
        const restoreTitle = () => { if (title.textContent !== title.dataset.bvTitle) title.textContent = title.dataset.bvTitle; };
        restoreTitle();
        new MutationObserver(restoreTitle).observe(title, {childList:true, characterData:true, subtree:true});
      }
      const dialog = root.querySelector('[data-bv-size-dialog]');
      root.querySelectorAll('[data-bv-size-guide]').forEach(button => {
        button.addEventListener('click', () => {
          const tables = [...root.querySelectorAll('[data-bv-description] table')].filter(table => /size|chest|waist|bust|length|shoulder/i.test(table.textContent));
          const target = dialog.querySelector('[data-bv-size-table]');
          target.replaceChildren(...tables.map(table => table.cloneNode(true)));
          target.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          dialog.querySelector('[data-bv-size-intro]').hidden = !tables.length;
          dialog.querySelector('[data-bv-size-fallback]').hidden = !!tables.length;
          dialog.showModal();
        });
      });
      dialog?.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      const productGallery = root.querySelector('product-gallery');
      const slider = productGallery?.querySelector('.product__media-list');
      function sliderItems() { return [...(slider?.querySelectorAll('.product__media-item') || [])].filter(item => !item.classList.contains('bv-pdp-media-hidden') && item.getBoundingClientRect().width > 0); }
      function updateSliderState() {
        if (!slider) return;
        const items = sliderItems();
        const gap = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : slider.clientWidth;
        const current = Math.min(items.length - 1, Math.max(0, Math.round(slider.scrollLeft / (gap || 1))));
        productGallery.classList.toggle('slider--no-buttons', items.length < 2);
        const previous = productGallery.querySelector('button[name="previous"]');
        const next = productGallery.querySelector('button[name="next"]');
        if (previous) previous.disabled = current <= 0;
        if (next) next.disabled = current >= items.length - 1;
        const currentCount = productGallery.querySelector('.slider-counter--current');
        const totalCount = productGallery.querySelector('.slider-counter--total');
        if (currentCount) currentCount.textContent = items.length ? current + 1 : 0;
        if (totalCount) totalCount.textContent = items.length;
      }
      if (slider) {
        productGallery.addEventListener('click', event => {
          const button = event.target.closest('button[name="previous"],button[name="next"]');
          if (!button) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const items = sliderItems();
          if (items.length < 2) return;
          const gap = items[1].offsetLeft - items[0].offsetLeft;
          const current = Math.round(slider.scrollLeft / gap);
          const next = Math.max(0, Math.min(items.length - 1, current + (button.name === 'next' ? 1 : -1)));
          slider.scrollTo({left: items[next].offsetLeft - items[0].offsetLeft, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, true);
        slider.addEventListener('scroll', updateSliderState, {passive:true});
        new ResizeObserver(updateSliderState).observe(slider);
        updateSliderState();
      }
      const picker = root.querySelector('variant-radios');
      if (!picker) return;
      const data = picker.querySelector('script[type="application/json"]');
      if (!data) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch { return; }
      const fields = [...picker.querySelectorAll('fieldset')];
      function updateGallery(selected) {
        const colourIndex = fields.findIndex(field => field.classList.contains('bv-pdp-colours'));
        if (colourIndex < 0 || fields[colourIndex].querySelectorAll('input').length < 2) return;
        const mediaIds = new Set(variants.filter(variant => variant.options[colourIndex] === selected[colourIndex] && variant.featured_media).map(variant => String(variant.featured_media.id)));
        const gallery = root.querySelector('product-gallery');
        if (!gallery) return;
        const items = [...gallery.querySelectorAll('.product__media-item')];
        const visible = items.filter(item => {
          const matches = mediaIds.has(item.dataset.mediaId.split('-').pop()) || (item.dataset.gangConnect && item.classList.contains('gang__active'));
          item.classList.toggle('bv-pdp-media-hidden', !matches);
          return matches;
        });
        const allowedMedia = new Set(visible.map(item => item.dataset.mediaId.split('-').pop()));
        root.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(item => {
          item.classList.toggle('bv-pdp-media-hidden', !allowedMedia.has(item.dataset.mediaId));
        });
        gallery.classList.toggle('bv-pdp-single-media', visible.length === 1);
        gallery.hidden = !visible.length;
        gallery.style.display = visible.length ? '' : 'none';
        const noImage = root.querySelector('[data-bv-no-colour-image]');
        if (noImage) noImage.hidden = !!visible.length;
        if (gallery.resetPages) gallery.resetPages();
        gallery.classList.toggle('slider--no-buttons', visible.length < 2);
        const counter = gallery.querySelector('.slider-counter--total');
        if (counter) counter.textContent = visible.length;
        if (visible.length === 1) {
          gallery.querySelector('.slider-counter--current').textContent = '1';
          gallery.querySelector('.product__media-list').scrollLeft = 0;
        }
        updateSliderState();
      }
      function updateAvailability() {
        const selected = fields.map(field => field.querySelector('input:checked')?.value);
        updateGallery(selected);
        fields.forEach((field, index) => {
          if (!field.classList.contains('bv-pdp-sizes')) return;
          field.querySelectorAll('input[type="radio"]').forEach(input => {
            input.disabled = !variants.some(variant => variant.available && variant.options[index] === input.value && variant.options.every((value, position) => position === index || value === selected[position]));
          });
        });
      }
      picker.addEventListener('change', updateAvailability);
      updateAvailability();
    }
    document.querySelectorAll('[data-bv-pdp]').forEach(initialise);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bv-pdp]').forEach(initialise));
  })();
  } catch(e) { console.error(e); }
})();

})();
